import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-input-dialog',
    templateUrl: './input-dialog.component.html'
  })
  export class InputDialogComponent {

    dialogForm: UntypedFormGroup;

    constructor(
      @Inject(MAT_DIALOG_DATA) public data,
      public dialogRef: MatDialogRef<InputDialogComponent>,
      private formBuilder: UntypedFormBuilder,
    ) {
      this.dialogForm = this.createDialogForm();
    }

    createDialogForm(): UntypedFormGroup {
      return this.formBuilder.group({
        name: [''],
        link: ['']
      });
    }

    onConfirm(): void {
      // Close the dialog, return true
      console.log(this.dialogForm.value);
      this.dialogRef.close(this.dialogForm.value);
    }

    onDismiss(): void {
      // Close the dialog, return false
      this.dialogRef.close(false);
    }
    closeDialog() {
      this.dialogRef.close(false);
    }
  }